export default __webpack_public_path__ + "logo-COM-desktop.svg";